export const FETCH_STOCK_MOVEMENTS_SUCCESS = "FETCH_STOCK_MOVEMENTS_SUCCESS";
export const FETCH_STOCK_MOVEMENTS_BEGIN = "FETCH_STOCK_MOVEMENTS_BEGIN";
export const FETCH_STOCK_MOVEMENTS_FAILURE = "FETCH_STOCK_MOVEMENTS_FAILURE";

export const UPDATE_STOCK_MOVEMENT_SUCCESS = "UPDATE_STOCK_MOVEMENT_SUCCESS";
export const UPDATE_STOCK_MOVEMENT_FAILURE = "UPDATE_STOCK_MOVEMENT_FAILURE";
export const UPDATE_STOCK_MOVEMENT_BEGIN = "UPDATE_STOCK_MOVEMENT_BEGIN";

export const DELETE_STOCK_MOVEMENT_BEGIN = "DELETE_STOCK_MOVEMENT_BEGIN";
export const DELETE_STOCK_MOVEMENT_SUCCESS = "DELETE_STOCK_MOVEMENT_SUCCESS";
export const DELETE_STOCK_MOVEMENT_FAILURE = "DELETE_STOCK_MOVEMENT_FAILURE";
